import * as actionTypes from "./actionTypes";

export const setRerender = () => ({
  type: actionTypes.SET_RERENDER,
});